export default __webpack_public_path__ + "static/media/im.6a64eb97.svg";